// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"Text--next-sr-only--2A-S_Jl","tagTextArea":"Text--tagTextArea--29RftJz"};